import { ReactElement } from 'react';
import A from '../A';
import styles from '../../pages/index.module.scss';

export default function SignInDisclaimer(): ReactElement {
  return (
    <p className={styles.disclaimer}>
      By signing in, you agree with the&nbsp;
      <A href="https://saucelabs.com/terms-of-service" newTab>
        Terms and Conditions
      </A>
      &nbsp;and&nbsp;
      <A href="https://saucelabs.com/privacy-policy" newTab>
        Privacy Policy
      </A>
    </p>
  );
}
